import { PrimaryCardButton } from "../component/CardButton";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";
import { Heading } from "../component/Heading";
import { CART_STORAGE_KEY } from "../const";
import NotFound from "./NotFound";
import { useEffect } from "react";
import { ROOT_URL } from "../config";
import { CampaignLoaderData } from "../Loader/compaignLoader";
import DOMPurify from "dompurify";

export default function Home() {
  const navigate = useNavigate();
  const loaderData = useRouteLoaderData("company-root") as CampaignLoaderData | undefined;
  const campaign = loaderData?.campaign ?? null;
  const campaignError = loaderData?.campaignError ?? null;
  const { company: companyParam } = useParams();
  useEffect(() => {
    try {
      sessionStorage.removeItem(CART_STORAGE_KEY);
    } catch (error) {
      console.error("Failed to clear sessionStorage:", error);
    }
  }, []);
  if (campaignError || !campaign) {
    return <NotFound />;
  }
  const goSetMenu = () => {
    console.log("Navigating to set menu list...");
    navigate(`/${companyParam}/setmenulist`); // relative path is safer with basename
  };
  console.log({ terms: campaign.attributes.terms })
  return (
    <main style={{ minHeight: "100vh", backgroundColor: "#f8f7f5" }}>

      {/* Banner Image - Full Width */}
      <div style={{ padding: "0 16px" }}>
        {campaign?.attributes.banner_web?.data?.attributes?.url && campaign?.attributes.banner_mobile?.data?.attributes?.url && (
          <picture style={{ display: "block" }}>
            <source media="(max-width: 768px)" srcSet={`${ROOT_URL}${campaign.attributes.banner_mobile.data.attributes.url}`} />
            <img
              src={`${ROOT_URL}${campaign.attributes.banner_web.data.attributes.url}`}
              alt="Banner"
              style={{
                display: "block",
                // width: "100%",
                maxWidth: "100%",
                borderRadius: 12,
                objectFit: "cover",
                boxShadow: "0px 7px 7.68px rgba(0, 0, 0, 0.1)",
                maxHeight: "90vh",
                margin: "0 auto",
              }}
            />
          </picture>)}
      </div>

      {/* CTA Button */}
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 32, paddingBottom: 32 }}>
        <PrimaryCardButton
          title="預訂平台"
          onClick={goSetMenu}
          icon={<img src="/assets/setMenu.svg" alt="Booking Icon" style={{ width: 20, height: 20 }} />}
        />

      </div>

      {/* Terms Section - Full Width */}
      {campaign?.attributes.terms && <div style={{
        width: "100%",
        backgroundColor: "white",
        padding: "40px 24px",
        height: "fit-content",
      }}>
        {/* <div style={{ margin: "0 auto", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
          {campaign.attributes.terms}
        </div> */}
        <div style={{ margin: "0 auto" }}>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(campaign.attributes.terms) }} />
          {/* {DOMPurify.sanitize(campaign.attributes.terms)} */}
        </div>
      </div>}

    </main>
  );
}